module.exports = __webpack_public_path__ + "img/4-4-marquee-4.6bc16853.jpg";